import PropTypes from "prop-types";
import Icon from "../Icon";

const EmptyComponent = () => null;

const CustomChip = ({
  value,
  iconName,
  iconSize,
  iconColor,
  bgColor,
  textColor,
  isIconify,
  IconComponent
}) =>
  <div
    style={{
      fontSize: '14px',
      backgroundColor: bgColor,
      borderRadius: '100px',
      padding: '3px 10px',
      color: textColor,
      fontWeight: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: "4px"
    }}
  >
    {(iconName && isIconify) && <Icon name={iconName} size={iconSize} color={iconColor}/>}
    {!isIconify && <IconComponent/>}
    {value}
  </div>

CustomChip.propTypes = {
  value: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  isIconify: PropTypes.bool,
  IconComponent: PropTypes.elementType,
}

CustomChip.defaultProps = {
    iconName: '', iconSize: '1em', iconColor: '', bgColor: '#E5F3FF', textColor: '#13315D', isIconify: false, IconComponent: EmptyComponent
}

export default CustomChip;